import { FiltersParams } from '@helpers/http.helper';
import { BalanceSharedFilters } from '@interfaces/balance-shared-filters';

export class BalanceFiltersHelper {
  static toParams(filters: BalanceSharedFilters): FiltersParams {
    return {
      amount: filters?.solde === 'positive' ? '<0' : filters?.solde === 'negative' ? '>=0' : undefined,
      has_comment: filters?.hasComment === 'all' ? undefined : filters.hasComment,
      has_attachment: filters?.hasAttachment === 'all' ? undefined : filters.hasAttachment,
      account_number_prefixes: filters?.accountNumberPrefixes ? filters.accountNumberPrefixes : undefined,
      pcg_entry_balanced: filters?.pcgEntryBalanced === 'all' ? undefined : filters.pcgEntryBalanced,
      pcg_entry_has_movement: filters?.pcgEntryHasMovement === 'all' ? undefined : filters.pcgEntryHasMovement,
      pcg_entry_validated: filters?.pcgEntryValidated === 'all' ? undefined : filters.pcgEntryValidated,
      expand: filters?.expand,
      date: filters?.date,
      pcg_entries: filters?.pcgEntryIds?.length ? filters.pcgEntryIds.join(',') : undefined,
      account_numbers: filters?.pcgEntryAccountNumbers?.length ? filters.pcgEntryAccountNumbers.join('|') : undefined
    };
  }
}
